import secondStepIcon from '../../../../assets/images/reg-guide/prescription.svg';
import firstStepIcon from '../../../../assets/images/reg-guide/mobile.svg';
import iconFirst from '../../../../assets/images/reg-guide/child-first-green.jpg';
import iconSecond from '../../../../assets/images/reg-guide/child-second-green.png';
import one from '../../../../assets/images/reg-guide/one-child.svg';
import two from '../../../../assets/images/reg-guide/two-child.svg';
import three from '../../../../assets/images/reg-guide/three-child.svg';
import oneAdult from '../../../../assets/images/reg-guide/one-adult.svg';
import twoAdult from '../../../../assets/images/reg-guide/two-adult.svg';

export const adultSteps = [{
  title: 'regGuide.step1.title',
  description: 'regGuide.step1.description',
  icon: firstStepIcon,
  actionHref: 'regGuide.step1.action.href',
  actionContent: 'regGuide.step1.action',
  index: 1,
  indexIcon: oneAdult,
}, {
  title: 'regGuide.step2.title',
  list: ['regGuide.step2.item-1', 'regGuide.step2.item-2'],
  isList: true,
  icon: secondStepIcon,
  index: 2,
  indexIcon: twoAdult,
}];

export const childSteps = [{
  title: 'regGuide.childSteps.step-1.title',
  description: 'regGuide.childsteps.step-1.description.new',
  actionHref: 'regGuide.step1.action.href',
  actionContent: 'regGuide.ecp.step1.action.child',
  index: 1,
  indexIcon: one,
}, {
  title: 'regGuide.childSteps.step-2.title',
  list: ['regGuide.childSteps.step-2.item-1', 'regGuide.childSteps.step-2.item-2'],
  iconFirst,
  iconSecond,
  isList: true,
  index: 2,
  indexIcon: two,
}, {
  title: 'regGuide.childSteps.step-3.title',
  list: ['regGuide.childSteps.step-3.item-1.new', 'regGuide.childSteps.step-3.item-2.new', 'regGuide.childSteps.step-3.item-3'],
  isList: true,
  index: 3,
  indexIcon: three,
}];
